<template>
  <transition name="slide-up">
    <div v-if="isVisible" class="workout-timer-floating">
      <v-card class="timer-card d-flex align-center pr-3 pl-1 py-1" dark :class="{ 'pulse-animation': remaining <= 10 }">
        <div class="timer-progress-wrapper mr-2">
          <v-progress-circular :rotate="-90" :size="42" :width="4" :value="progress" :color="progressColor" class="timer-progress">
            <v-icon small :color="progressColor">mdi-timer-outline</v-icon>
          </v-progress-circular>
        </div>
        <div class="timer-info">
          <div
            class="caption font-weight-bold grey--text text--lighten-1 line-height-1 mb-0"
            style="font-size: 0.7rem !important; letter-spacing: 0.5px">
            PAUSE
          </div>
          <div class="timer-value font-weight-black text-h6 line-height-1" :class="textColor" style="font-feature-settings: 'tnum'">
            {{ formattedTime }}
          </div>
        </div>
      </v-card>
    </div>
  </transition>
</template>

<script>
// ... (script part remains mostly same, just checking if I need to add anything for animation)
import { mapGetters, mapActions } from "vuex"

export default {
  name: "WorkoutTimer",
  data() {
    return {
      remaining: 0,
      interval: null,
      hasVibrated: false,
    }
  },
  computed: {
    ...mapGetters("runWorkoutStore", ["timerState"]),
    isVisible() {
      return this.timerState.isActive && this.timerState.isMinimized
    },
    // ... other computed props
    progress() {
      if (!this.timerState.originalDuration) return 0
      if (this.remaining < 0) return 100

      const p = (this.remaining / this.timerState.originalDuration) * 100
      return Math.min(100, Math.max(0, p))
    },
    formattedTime() {
      const absSeconds = Math.abs(this.remaining)
      const m = Math.floor(absSeconds / 60)
      const s = absSeconds % 60
      const timeStr = `${m < 10 ? "0" + m : m}:${s < 10 ? "0" + s : s}`

      if (this.remaining < 0) return `+${timeStr}`
      return timeStr
    },
    progressColor() {
      if (this.remaining <= 0) return "red accent-2"
      if (this.remaining <= 10) return "orange"
      return "#00E676"
    },
    textColor() {
      if (this.remaining <= 5) return "red--text text--accent-2"
      return "white--text"
    },
  },
  watch: {
    "timerState.isActive": {
      immediate: true,
      handler(isActive) {
        if (isActive) {
          this.startLocalTicker()
        } else {
          this.stopLocalTicker()
        }
      },
    },
    "timerState.startTime": {
      handler() {
        if (this.timerState.isActive) {
          this.updateTime()
          this.hasVibrated = false
        }
      },
    },
  },
  methods: {
    ...mapActions("runWorkoutStore", ["maximizeTimer", "stopTimer"]),
    startLocalTicker() {
      this.stopLocalTicker()
      this.updateTime()
      this.interval = setInterval(this.updateTime, 1000)
    },
    stopLocalTicker() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },
    updateTime() {
      if (!this.timerState.startTime || !this.timerState.duration) return

      const elapsed = Math.floor((Date.now() - this.timerState.startTime) / 1000)
      const r = this.timerState.duration - elapsed

      this.remaining = r

      if (this.remaining <= 0 && !this.hasVibrated) {
        this.triggerVibration()
        this.hasVibrated = true
      }
    },
    triggerVibration() {
      if (navigator.vibrate) {
        navigator.vibrate([200, 100, 200])
      }
    },
    maximize() {
      this.maximizeTimer()
    },
  },
  beforeDestroy() {
    this.stopLocalTicker()
  },
}
</script>

<style scoped>
.workout-timer-floating {
  position: fixed;
  bottom: 90px;
  right: 16px;
  z-index: 2000;
  cursor: pointer;
  max-width: 50vw;
}

.timer-card {
  border-radius: 50px;
  background: rgba(30, 30, 30, 0.9) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4) !important;
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.timer-card:active {
  transform: scale(0.95);
}

.pulse-animation {
  animation: pulse-border 2s infinite;
}

@keyframes pulse-border {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}

.line-height-1 {
  line-height: 1;
}

/* Animation */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100px) scale(0.8);
  opacity: 0;
}
</style>
